<template>
  <a-modal
    v-model:visible="rate.visible"
    title="满意度评价"
    :width="480"
    :confirm-loading="confirmLoading"
    :ok-button-props="{ disabled: !canIRate }"
    style="top: 229px"
    @ok="handleOk"
    :footer="canRate ? (isNeedRate ? undefined : null) : null"
  >
    <div class="rateModal">
      <div v-if="isNeedRate" class="rateTitle">请按照患者的评价填写本次对医生问诊服务的满意度</div>
      <div class="auditStatus" v-if="!isNeedRate">
        <auth-img
          mode="ant"
          :preview="false"
          :src="rate.auditStatus[rateInfo.evaluateStatusString]"
        />
      </div>
      <div class="z-fixed">
        <div class="headImg">
          <auth-img mode="ant" :src="doctorInfo.headUrl" :fallback="head_d" />
        </div>
        <div>
          <div class="topTxt">
            <span>{{ rateInfo.doctorName }}</span>
            <auth-img mode="ant" :width="16" :src="doLabel" />
          </div>
          <div class="btmTxt">
            {{ rateInfo.academicTitle }}
            <span v-show="rateInfo.academicTitle && rateInfo.departmentName">|</span>
            {{ rateInfo.departmentName }}
          </div>
        </div>
      </div>
      <div class="z-fixed" :class="[isNeedRate ? 'writeAble' : 'readOnly']">
        <a-rate
          :disabled="isNeedRate ? false : true"
          v-model:value="rate.rateValue"
          style="font-size: 36px"
          :maskClosable="false"
        />
      </div>
      <div class="evTitle">
        评价内容：
        <span class="alert">（三分及以下需填入评价内容）</span>
      </div>
      <a-textarea v-if="isNeedRate" v-model:value="rateInfo.content" show-count :maxlength="200" />
      <div class="evText" v-else>
        <a-divider />
        <p>{{ rateInfo.content || '--' }}</p>
        <a-divider />
        <p>评价人：{{ rateInfo.evaluatorName }}</p>
        <p>评价时间：{{ rateInfo.evaluateTime || '--' }}</p>
      </div>
    </div>
  </a-modal>
</template>
<script setup>
import { ref, reactive, defineExpose, defineEmits, defineProps, computed } from 'vue'
import { useStore } from 'vuex'
import { goEvaluate, getEvaluation } from '@/api/workPlace/consult'
import { message } from 'ant-design-vue'
import head_d from '@/assets/img/chat/head_d.png'
import doLabel from '@/assets/img/evaluation/doLabel.png'
import unAudit from '@/assets/img/evaluation/unAudit.png'
import passAudit from '@/assets/img/evaluation/passAudit.png'
import failAudit from '@/assets/img/evaluation/failAudit.png'
import select from '@/assets/img/evaluation/select.png'

const props = defineProps({
  isNeedRate: {
    // 是否评价过
    type: Boolean,
    default: false
  },
  canRate: {
    // 可不可以评价
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['refresh', 'update:isNeedRate'])

const confirmLoading = ref(false)

const rateInfo = ref({})
const rate = reactive({
  visible: false,
  rateValue: 0,
  evaluationId: null,
  auditStatus: { 待审核: unAudit, 审核通过: passAudit, 审核不通过: failAudit, 精选: select } // 后端返回string
})

const EvaluationMethod = (rateId = null) => {
  getEvaluation({ evaluationId: rate.evaluationId || rateId }).then(res => {
    const isRate = res.evaluateStatus === 0
    emit('update:isNeedRate', isRate)
    rate.rateValue = res.score
    rateInfo.value = res
  })
}

const canIRate = computed(() => {
  if (!props.isNeedRate) return
  const rateNum = Number(rate.rateValue)
  const isHaveContent = rateInfo.value.content
  if (rateNum <= 3) {
    // 若低于三分 并且有评价内容才可以提交
    return Boolean(isHaveContent.trim())
  }
  // 若高于三分 评价内容非必填
  return true
})

const store = useStore()
const doctorInfo = computed(() => store.state.workOrder.workOrderGroupInfo.doctorInfo)
const handleOk = () => {
  confirmLoading.value = true
  goEvaluate({
    score: rate.rateValue,
    evaluationId: rate.evaluationId,
    content: rateInfo.value.content
  })
    .then(() => {
      message.success('评价成功！')
      rate.visible = false
      emit('update:isNeedRate', false)
      // 打分后执行refresh
      props.isNeedRate && emit('refresh')
    })
    .finally(() => {
      confirmLoading.value = false
    })
}
defineExpose({
  rate,
  EvaluationMethod
})
</script>
<style scoped lang="scss">
.rateModal {
  padding: 0 16px;
  position: relative;
  .rateTitle {
    font-weight: 550;
    font-size: 16px;
    color: #3b3b3b;
    margin-bottom: 28px;
  }
  .auditStatus {
    width: 148px;
    height: 75px;
    position: absolute;
    top: -10px;
    right: 20px;
  }
  .writeAble {
    display: flex;
    justify-content: center;
    margin: 22px 0 28px 0;
    padding: 15px 0 22px 0;
    border-radius: 6px;
    border: 1px solid #eee;
  }
  .readOnly {
    display: flex;
    align-items: flex-start;
    margin: 20px 0;
  }
  .evTitle {
    font-weight: 550;
    font-size: 16px;
    color: #3b3b3b;
    margin-bottom: 8px;
    .alert {
      font-size: 14px;
      color: #999999;
    }
  }
  .evText {
    font-size: 14px;
    color: #999999;
  }
  .headImg {
    width: 52px;
    min-width: 52px;
    height: 52px;
    border-radius: 4px;
    margin-right: 12px;
    overflow: hidden;
  }
  .topTxt {
    font-weight: 550;
    font-size: 16px;
    color: #1a1a1a;
    span {
      margin-right: 8px;
    }
  }
  .btmTxt {
    margin-top: 4px;
    font-size: 14px;
    color: #9e9e9e;
  }
  ::v-deep(.ant-rate) {
    color: #ffa940;
  }
  ::v-deep(.ant-rate-star:not(:last-child)) {
    margin-right: 16px;
  }
}
</style>
